import React, { useEffect } from 'react';
import LogoIcon from '../../img/svg/logo-icon.svg'
import Logo from '../../img/svg/logo-white.svg'
import LogoGold from '../../img/logo-gold.svg'

import {
  Container,
  Header,
  Img,
  NameRow,
  ImgLogo,
  PageOne,
} from '../CFP/styles'
import TextsHeader from '../CFP/TextsHeader';
import StaticGraph from '../CFP/graphs/staticGraph';
import MediaPonderada from '../CFP/mediaPonderada';
import GeralResults from '../CFP/GeralResults';
import PropTypes from 'prop-types'
import { connect, useSelector, useDispatch } from 'react-redux'
import { actions as studentActions } from '../../redux/modules/student';
import * as studentSelectors from '../../redux/selectors/student'
import { FooterReport } from '../CFP/Weekly/PDF/Class/styles';
import ReportText from '../CFP/Report/TextDescription';
import {
  getSusgestionByScoreToro,
  TYPE_SCORE_INFORMATION_REPORT_PDF,
  TYPE_SCORE_INFORMATION_REPORT_SIMULATED,
} from '../CFP/common';
import SimulatedPerModules from '../CFP/Report/SimulatedPerModules';
import { isEmpty } from 'lodash';
import { fetchGeneralText } from '../../redux/api/class';
import useExamType from '../../hooks/useExamType';

const propTypes = {
  handleCfpSimulado: PropTypes.func.isRequired,
  isFetchCfpsimulado: PropTypes.bool.isRequired
}

function ExamReportPdf({ handleCfpSimulado, isFetchCfpsimulado }) {
    const [textData, setTextData] = React.useState('')
    const examConfig = useExamType();

    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get('user_id')
    const courseId = urlParams.get('course_id')
    const classId = urlParams.get('class_id')
    const start = urlParams.get('start')
    const media = urlParams.get('media')
    const end = urlParams.get('end')
    const kind = urlParams.get('kind')
    const classes = urlParams.get('classes')

    const { reportSimulado, scoreToroInformation } = useSelector((state) => state.student);
    const suggestion = getSusgestionByScoreToro(scoreToroInformation, Number(((reportSimulado?.average?.acertos_avg ?? 0) * 100).toFixed(1)))
    const dispatch = useDispatch();

    useEffect(() => {
        handleCfpSimulado(userId, courseId, classId, media, start, end, kind, classes, examConfig.examType)

        dispatch(studentActions.getScoreToroSugestionsByTypes(
          examConfig.courseCategory,
          TYPE_SCORE_INFORMATION_REPORT_PDF,
          TYPE_SCORE_INFORMATION_REPORT_SIMULATED
        ));
        // eslint-disable-next-line
    }, [examConfig.courseCategory])

    useEffect(()=>{
      (async ()=>{
        try {
          const filters = examConfig.examType === 'cfa' ? {
            typeReportId: 1,
            courseCategoryId: 15,
            categoryReportId: 1
          } : {
            typeReportId: examConfig.courseCategory,
            categoryReportId: TYPE_SCORE_INFORMATION_REPORT_SIMULATED
          }
          const textDataApi = await fetchGeneralText(filters)
          if(textDataApi[0]?.content !== undefined){
            setTextData(textDataApi[0]?.content)
          }
        } catch (error) {
          console.error('Erro ao buscar texto do relatório:', error)
          setTextData('')
        }
      })()
    },[examConfig.courseCategory, examConfig.examType])

    const isReportSimuladoEmpty = isEmpty(reportSimulado);

    const done = isReportSimuladoEmpty || isEmpty(reportSimulado?.test) ? 0 : reportSimulado?.test?.done[0]?.prova ?? 0;
    const toBeDone = isReportSimuladoEmpty || isEmpty(reportSimulado?.test) ? 30 : reportSimulado?.test?.to_be_done[0]?.prova ?? 0;

  return (
    <>
      {isFetchCfpsimulado || reportSimulado === null ? ('...carregando') : (
        <>
          <Header>
            <Img src={Logo} alt="logo" />
          </Header>

          <Container>
            <PageOne>
              <NameRow>
                <h1>Olá {reportSimulado?.name} :)</h1>
                <ImgLogo src={LogoIcon} alt="logo" />
              </NameRow>

              <TextsHeader>
                <div dangerouslySetInnerHTML={{ 
                  __html: textData
                    .replace("#done#", done)
                    .replace("#toBeDone#", toBeDone)
                    .replace(/CFP/g, examConfig.displayName)
                    .replace(/Certified Financial Planner/g, examConfig.texts.fullExamName)
                }} />
              </TextsHeader>

              <StaticGraph examType={examConfig.examType} />

              <MediaPonderada data={reportSimulado} examType={examConfig.examType} />
            </PageOne>
            <div className='reportContainer'>
              
              <SimulatedPerModules data={reportSimulado} examType={examConfig.examType} />
              
              <GeralResults data={reportSimulado} examType={examConfig.examType} />

              <div style={{ marginTop: '250px' }}>
              <ReportText type="description" dangerouslySetInnerHTML={{ 
                __html: suggestion
                  ?.replace('{name}', reportSimulado?.name)
                  ?.replace(/CFP/g, examConfig.displayName)
                  ?.replace(/Certified Financial Planner/g, examConfig.texts.fullExamName)
              }} />
                            
                <FooterReport style={{marginTop: "50px"}}>
                  <div className='logo-gold'>
                    <img src={LogoGold} alt='logo' />
                  </div>
                  <div className='description-footer'>
                    <p>{examConfig.texts.footerMessage}</p>
                    <p>Um grande abraço dos professores e amigos Rafael Toro, Victório Santi e equipe ART.</p>
                  </div>
                </FooterReport>
              </div>
            </div>
          </Container>
        </>
      )}
    </>

  );
};

const mapStateToProps = (state, props) => {
  return {
    student: studentSelectors.getCfpSimulado(state, props),
    isFetchCfpsimulado: studentSelectors.isFetchCfpsimulado(state, props),
  }
}

const mapDispatchToProps = dispatch => ({
    handleCfpSimulado: (userId, courseId, classId, media, start, end, kind, classes, examType) => (
        dispatch(studentActions.handleCfpSimulado(userId, courseId, classId, media, start, end, kind, classes, examType))
    )
})

ExamReportPdf.propTypes = propTypes
export default connect(mapStateToProps, mapDispatchToProps)(ExamReportPdf)
